<template>
  <div
    class="switcher-inner-wrapper"
    :class="{'border': !noBorder}"
  >
    <div class="placeholder" :class="type" />
  </div>
</template>

<script>
/** Types **/
const TYPES = ['timeline', 'breakdown', 'table']

export default {
  name: 'IbChartsPlaceholderType',

  props: {
    type: {
      type: String,
      validator: value => {
        return TYPES.includes(value)
      },
      default: 'timeline'
    },

    noBorder: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.switcher-inner-wrapper {
  position: relative;
  border-radius: 0 0 8px 8px;
  min-height: 320px;
  max-width: 1198px;
  background-color: $color-white;
  padding: 0 10px;

  &.border {
    border: 1px solid rgba(0, 0, 0, 0.12);
  }

  .placeholder {
    border-radius: 0 8px 8px 8px;
    width: 100%;
    height: auto;
    min-height: 320px;
    margin: 20px 0;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    &.breakdown {
      background-image: asset("img/placeholders/graph-dummy-sm.svg");
    }

    &.timeline {
      background-image: asset("img/placeholders/timeline-graph-sm.svg");
    }

    &.table {
      background-image: asset("img/placeholders/table-graph-sm.svg");
    }

    @include media-breakpoint-up($sm) {
      background-size: contain;

      &.breakdown {
        background-image: asset("img/placeholders/graph-dummy-md.svg");
      }

      &.timeline {
        background-image: asset("img/placeholders/timeline-graph-md.svg");
      }

      &.table {
        background-image: asset("img/placeholders/table-graph-md.svg");
      }
    }

    @include media-breakpoint-up($lg) {
      &.breakdown {
        background-image: asset("img/placeholders/graph-dummy.svg");
      }

      &.timeline {
        background-image: asset("img/placeholders/timeline-graph.svg");
      }

      &.table {
        background-image: asset("img/placeholders/table-graph.svg");
      }
    }
  }
}
</style>
